import { useEffect } from "react";
import { Outlet } from "react-router";
import initPushNotifications from "utils/initPushNotifications";

const WithPushNotifications = () => {
  useEffect(() => {
    initPushNotifications();
  }, []);

  return <Outlet />;
};

export default WithPushNotifications;
